// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6k-0";
export var startPickingButton = "_6k-1";